<template>
  <IQOS :title="$t('reminder_timeout_panel.title')"
    :enabled="is_active">
    <BaseUnitInput
      @blur="save"
      v-model.number="timeout"
      type="number"
      :unitPlaceholder="$t('units.mins')"
      fullWidth
      placeholder="5"
      class="mt-16"
      :readonly="false"
      :valid="!invalid"
      v-if="is_active"
    />
    <p class="iqos-comment mt-16">
      {{ $t("reminder_timeout_panel.comment") }}
    </p>

    <template #actions>
        <IQOSToggle :value="is_active" @input="toggleActive"/>
    </template>
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      timeout: 7,
      invalid: false,
      is_active: false
    };
  },
  methods: {
    save() {
      this.invalid = false;
      this.$store.commit("setReminderTimeout", this.timeout);
      this.$store.dispatch("saveCafe");
    },
    toggleActive(v) {
        if (v) {
            this.is_active = true;
            this.timeout = 7;
            this.save();
        } else {
            this.is_active = false;
            this.timeout = 0;
            this.save();
        }
    }
  },
  mounted() {
    this.timeout = this.$store.state.cafe.order_reminder_timeout;
    this.is_active = this.timeout !== 0;
  },
};
</script>

<style>
</style>